import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { useBookingStateContext } from "hooks/use-booking-state";
import { Routes } from "routes";
import { State } from "store/store-types";
import { UnitMetaDataExternal } from "types/external-booking-settings";

export enum ActiveStep {
    Guests,
    GuestsChildren,
    Date,
    Preorder,
    Availability,
    Finalize,
}

function getActiveStep(state: State, unitMetaData: UnitMetaDataExternal) {
    const { maxWebGuests, activateWebChildren } = unitMetaData;
    const { guests, guestsChildren, date } = state;
    const tooManyGuests = maxWebGuests && (guests ?? 0) > maxWebGuests;
    const isRequestFlow = location.pathname.includes(Routes.BOOKING_REQUEST);

    const isPreorderActiveStep = location.pathname.includes(Routes.PREORDER);
    if (isPreorderActiveStep) {
        return ActiveStep.Preorder;
    }

    const isTimesActiveStep = location.pathname.includes(Routes.AVAILABILITY);
    if (isTimesActiveStep) {
        return ActiveStep.Availability;
    }

    const isFinalizeActiveStep = location.pathname.includes(Routes.FINALIZE);
    if (isFinalizeActiveStep) {
        return ActiveStep.Finalize;
    }

    if (!guests || (tooManyGuests && !isRequestFlow)) {
        return ActiveStep.Guests;
    }

    if (activateWebChildren && guestsChildren === null && !isRequestFlow) {
        return ActiveStep.GuestsChildren;
    }
    if (!date) {
        return ActiveStep.Date;
    }
    return ActiveStep.Finalize;
}

export const useActiveStep = () => {
    const unitsMetaData = useExternalBookingSettings().data?.unitsMetaData;
    const state = useBookingStateContext();

    if (!unitsMetaData) {
        return ActiveStep.Guests;
    }
    return getActiveStep(state, unitsMetaData);
};
